import React, { useState } from 'react';
import {
  HStack,
  Text,
  Select,
  Button,
  IconButton,
  useToast,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import { PayoutSchedule } from '@Encore-FastStartup-Phase-Out/encore-shared';

import { useStore } from '../../hooks/useStore';

const PayoutScheduleSetting: React.FC = () => {
  const {
    userStore: { displayedUser, updateUser },
  } = useStore();
  const [isEditing, setIsEditing] = useState(false);
  const [payoutSchedule, setPayoutSchedule] = useState(
    displayedUser.payoutSchedule,
  );
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleEdit = () => setIsEditing(true);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setPayoutSchedule(event.target.value as PayoutSchedule);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      await updateUser(displayedUser.id, {
        payoutSchedule,
      });
      setIsEditing(false);
      toast({
        title: 'Success',
        description: 'Payout schedule updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
      toast({
        title: 'Error',
        description: 'Failed to update payout schedule',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getDisplayValue = (schedule: PayoutSchedule) => {
    switch (schedule) {
      case PayoutSchedule.ON_DELIVERY:
        return 'On Delivery';
      default:
        return schedule
          .toString()
          .replace(/_/g, ' ')
          .toLowerCase()
          .replace(/\b\w/g, (l) => l.toUpperCase());
    }
  };

  const getPayoutScheduleOptions = () => {
    return Object.values(PayoutSchedule).map((value) => ({
      value,
      label: getDisplayValue(value),
    }));
  };

  return (
    <HStack w="100%" justify="center" p={2} gap={10}>
      <Text fontWeight="bold">Payout Schedule:</Text>
      {isEditing ? (
        <>
          <Select value={payoutSchedule} onChange={handleChange}>
            {getPayoutScheduleOptions().map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
          <Button onClick={handleSave} isLoading={loading}>
            Save
          </Button>
        </>
      ) : (
        <HStack>
          <Text pr={10}>{getDisplayValue(payoutSchedule)}</Text>
          <IconButton
            aria-label="Edit payout schedule"
            icon={<FaEdit />}
            onClick={handleEdit}
          />
        </HStack>
      )}
    </HStack>
  );
};

export default PayoutScheduleSetting;
